










































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Relationship from './Relationship.vue'

export default mixins(DiaryMixin).extend({
  components: { Relationship },
})
